// removed by extract-text-webpack-plugin
module.exports = {"root":"_3yTkA","desktopStyle":"_Fl6q9","mobileStyle":"_3-Wsj","content":"_1THjf","icon":"_2UTOj","banner":"_21icB","hiddenContent":"_1pR4_","jelly":"_3Tc4O","slideInLeft":"_1-Yg5","slideInUp":"_2A8vE","pop-in":"_DZ-HA","fadeIn":"_1JKGj","spin":"_xL-B2"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Mission/components/Feature/Feature.scss
// module id = 1263
// module chunks = 7